import { render, staticRenderFns } from "./subjectReport.vue?vue&type=template&id=dc0972f8&scoped=true"
import script from "./subjectReport.vue?vue&type=script&lang=js"
export * from "./subjectReport.vue?vue&type=script&lang=js"
import style0 from "./subjectReport.vue?vue&type=style&index=0&id=dc0972f8&prod&lang=css&scoped=true"
import style1 from "./subjectReport.vue?vue&type=style&index=1&id=dc0972f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0972f8",
  null
  
)

export default component.exports